import { useContext, useEffect } from 'react';
import {
  MembershipEnum,
  ProgramTypeEnum,
  VoloPassSaleBannerOverlay,
} from '@rivallapp/volosports-components';

import { RegistrationActions } from '../../../../../contexts/RegistrationContext/RegistrationReducer';
import { RegistrationContext } from '../../../../../contexts';
import { useVoloPassDetails } from '../../../../../hooks';
import usePaymentSummary from '../../hooks/usePaymentSummary';

const { UPDATE_REGISTRATION_STATE } = RegistrationActions;

const VoloPassTrialPopup = () => {
  const [registerState, registerDispatch] = useContext(RegistrationContext);

  const { afterExpireDate } = useVoloPassDetails();

  const {
    showVpPopup,
    shouldGrantTrial,
    paymentSources,
    league,
    addVpMembership,
    addVpTrial,
    membershipExpires,
    programType,
    isDropIn,
    usePaymentSummaryProps,
  } = registerState;

  const { setPricingSelected } = usePaymentSummaryProps;

  const { memberPriceInCents, nonmemberPriceInCents } = usePaymentSummary(
    isDropIn ? 'dropin' : 'non-dropin'
  );

  // if isVoloPassTrialActive === true -> show popup with trial info
  // if isVoloPassTrialActive === false -> show popup with membership info
  useEffect(() => {
    if (
      league?.organization?.voloPassTiers?.isActive &&
      (!membershipExpires || afterExpireDate) &&
      shouldGrantTrial &&
      !addVpMembership &&
      !addVpTrial
    ) {
      registerDispatch({
        type: UPDATE_REGISTRATION_STATE,
        update: { showVpPopup: true },
      });
    }
  }, [
    league?.organization?.voloPassTiers?.isActive,
    afterExpireDate,
    addVpMembership,
    addVpTrial,
    membershipExpires,
    paymentSources,
    registerDispatch,
    shouldGrantTrial,
  ]);

  const handleClosePopup = () =>
    registerDispatch({
      type: UPDATE_REGISTRATION_STATE,
      update: { showVpPopup: false },
    });

  return (
    <VoloPassSaleBannerOverlay
      isOpen={showVpPopup}
      onClose={handleClosePopup}
      memberPriceInCents={memberPriceInCents}
      nonmemberPriceInCents={nonmemberPriceInCents}
      programType={isDropIn ? ProgramTypeEnum.DROPIN : programType}
      isDryMarket={league?.organization?.is_dry ?? false}
      onPressAddToCart={() => {
        setPricingSelected(MembershipEnum.VOLO_PASS);
        handleClosePopup();
      }}
    />
  );
};

export default VoloPassTrialPopup;
